








import {Component, Mixins} from 'vue-property-decorator';
import vSelect from '@/components/UI/vSelect.vue';
import Http from '../mixins/http';
import LocalData from '../mixins/local-data';

@Component({
    components: {
        vSelect,
    },
})

export default class Help extends Mixins(LocalData, Http) {

}
